define('root/app_store/Podio.UI.AppStore.SharesView',['require','translate','underscore','jquery','root/app_store/Podio.UI.AppStore.ListView','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.UI.Modal','lib/Podio.Event.UI','lib/Podio.Event'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var listView = require('root/app_store/Podio.UI.AppStore.ListView');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var modal = require('lib/Podio.UI.Modal');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');

  function onDomReady() {

    var elmListViews = $('.app-store-shares-listview');
    var requests = [];

    _.each(elmListViews, function(domListView) {

      var state = {
        offset : {
          current: 0,
          next: 0,
          prev: 0
        }
      };

      var elmListView = $(domListView);
      var shareType = elmListView.data('share-type');
      var refType = elmListView.data('ref-type');
      var refId = elmListView.data('ref-id');
      var pageSize = elmListView.data('page-size');

      var sharesListView = new listView(elmListView, {
        state: state,
        shareType: shareType,
        refType: refType,
        refId: refId,
        pageSize: pageSize,
        enableSorting: false,
        initialHide: true
      });

      var req = sharesListView.getPage(0);
      requests.push(req);

    });

    $.when.apply(this, requests ).done(function() {
      $('.app-store-shares-list').removeClass('loading-overlay-big-top');
    });
  }

  function onDeleteShareClicked(elmTarget, e) {

    var elmListItem = elmTarget.parents('.app-store-share');
    var shareId = elmListItem.data('share-id');
    var url = routes.app_store_destroy_path(shareId);

    modal.showConfirm(t('Delete share #store'), t('You are about to delete this share #store'), null, {yes: t('Yes, delete #store'), no: t('Cancel') }, function() {

      var req = transport.deleteJSON(url);
      req.done(function(responseData) {
        elmListItem.remove();
      });


    });
  }

  // Init
  podioEvent.bind(podioEvent.Types.init, onDomReady);

  eventUI.bind('click', '.app-store-shares-listview .delete-share ', onDeleteShareClicked);

});



